import Chip from '@ixigo/iui/Chip';
import type { TimelineItemProps } from '@ixigo/iui/Timeline';
import * as Timeline from '@ixigo/iui/Timeline';
import type { TimelineItem } from './hooks/useTimelineItems';
import { LocationLabel } from './location-label';
import { LocationSubtext } from './location-subtext';
import { TimelineIndicator } from './timeline-icons';

export const CabTimelineContent = ({
	item,
}: {
	item: Extract<TimelineItem, { type: 'cab' }>;
}) => (
	<div className="flex py-0.5">
		<Chip size="xs" variant="soft" color="neutral" clickable={false}>
			{item.distance}
		</Chip>
	</div>
);

export const LocationTimelineContent = ({
	item,
}: {
	item: Extract<TimelineItem, { type: 'pickup' | 'drop' }>;
}) => (
	<div className="pb-2.5">
		<LocationLabel label={item.location.label} className="truncate relative" />
		<LocationSubtext label={item.location.subText} time={item.location.time} />
	</div>
);

export const RideTimelineContent = ({ item }: { item: TimelineItem }) => {
	switch (item.type) {
		case 'cab':
			return <CabTimelineContent item={item} />;
		case 'pickup':
		case 'drop':
			return <LocationTimelineContent item={item} />;
		default: {
			return null;
		}
	}
};

export interface RideTimelineItemProps extends TimelineItemProps {
	item: TimelineItem;
	isLast: boolean;
}

export const RideTimelineItem = ({ item, isLast }: RideTimelineItemProps) => {
	return (
		<Timeline.Item key={item.id} className="relative">
			<Timeline.Separator
				indicator={<TimelineIndicator item={item} />}
				connector={
					<div
						className={`w-px h-full border-l border-secondary ${isLast ? 'hidden' : ''}`}
					/>
				}
				// // Todo: Size will be removed from the timeline.Item in the future.
				className="!w-20"
			/>
			<Timeline.Content className="overflow-hidden">
				<RideTimelineContent item={item} />
			</Timeline.Content>
		</Timeline.Item>
	);
};
